/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.transfer.info.Params, options?: any) {
  return updateResponse(
    http(URL + `/transfer/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
